import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/gruposDeFeriados/holidaysGroups";
import holidaysGroup from "../../models/gruposDeFeriado/holidaysGroup";
import holidays from "../../models/gruposDeFeriado/holidays";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: '10px',
    holidaysGroups:[],
    holidays:[],
    openConcepts: false,
    mode: 'Agregar grupo de feriado',
    new: {},
    edit: {},
    newHolidays:[],
    itemDelete: null,
    openDelete: false
  },

  mutations: {
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setHolidaysGroups(state, data) {
      state.holidaysGroups = data;
    },
    setHolidays(state, data) {
      state.holidays = data;
    },
    setOpenConcept(state, data) {
      state.openConcepts = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setNewGroupHoliday(state, data) {
      state.new = data;
    },
    setEditGroupHoliday(state, data) {
      state.edit = data;
    },
    setNewHolidays(state, data){
      state.newHolidays=data;
    }
  },
  actions: {
    async getGroupsHolidays(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getGroupsHolidays();
          state.commit("setHolidaysGroups", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getHolidays(state){
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getHolidays();
          state.commit("setHolidays", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });

    },

    async getGroupHolidayId({ state, commit }, tipoFerId) {
      try {
        const data = await state.service.getGroupHolidayId(tipoFerId);
        commit("setEditGroupHoliday", data);
        return true; 
      } catch (error) {
        throw error;
      }
    },

    async addHolidays(state){
      try {
        await state.state.service.addHolidays(state.state.newHolidays)
        .then(() => {
          resolve(true);
          });
      } catch (error) {
        return false;
      }
    },

    async addGroupHoliday(state) {
      try {
        await state.state.service.addGroupHoliday(state.state.new)
        .then(({ data }) => {
          let item = state.state.new;
          let options = state.state.holidaysGroups;
          let newItem = holidaysGroup.fromJson({
            tipoFerId:data.tipoFerId,
            nombre:item.nombre
          });
          options.push(newItem);
          state.commit("setHolidaysGroups", options);
          resolve(true);
          });
      } catch (error) {
        return false;
      }
    },
    async deleteGroupHoliday(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.deleteGroupHoliday(state.state.itemDelete).then(() => {

            let options = state.state.holidaysGroups
            options = options.filter(option => {
              return option.id != state.state.itemDelete
            })
            state.commit('setHolidaysGroups', options)
            resolve(true)
          });
        } catch (error) {
          reject(error)

        }
      })
    },

    async editGroupHoliday(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.editGroupHoliday(state.state.edit).then(() => {
            let item = state.state.edit;
            let options = state.state.holidaysGroups
            options = options.map((option) => {
              if (option.id !== item.id) {
                return option
              }
              
              item = holidaysGroup.fromJson({
                tipoFerId: item.tipoFerId,
                nombre: item.nombre,
              });
              return item
            });

            state.commit('setHolidaysGroups', options)
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },


  },
});
